import { setContext } from '@apollo/client/link/context';
import { from, HttpLink, ApolloClient, InMemoryCache } from '@apollo/client';

import { JWT_STORAGE_KEY } from 'src/auth/context/jwt/constant';

// ----------------------------------------------------------------------

const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include',
});

const authLink = setContext((_, { headers }) => {
  let token: string | null = null;

  if (typeof window !== 'undefined') {
    try {
      token = window.sessionStorage.getItem(JWT_STORAGE_KEY);
    } catch {
      token = null;
    }
  }

  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
});
